export const NAV = [
  { id: "home", label: "Home", testId: "nav-link-home" },
  { id: "story", label: "Our Story", testId: "nav-link-story" },
  { id: "products", label: "Products", testId: "nav-link-products" },
  { id: "b2b", label: "B2B Advantage", testId: "nav-link-b2b" },
  { id: "distributor", label: "Become a Distributor", testId: "nav-link-distributor" },
  { id: "contact", label: "Contact", testId: "nav-link-contact" },
];

export const CONTACT = {
  phone: "+91 9304854064",
  phoneHref: "tel:+919304854064",
  phone2: "+91 9142285423",
  phone2Href: "tel:+919142285423",
  whatsapp: "https://wa.me/919142285423",
  email: "care@nutriswaad.com",
  website: "www.nutriswaad.com",
  websiteHref: "https://www.nutriswaad.com",
  location: "West Champaran, Bihar, India",
  salesContact: "Rohit Kumar Gupta (Sales Head)",
  instagram: "https://www.instagram.com/nutri_swaad",
  youtube: "https://www.youtube.com/@Nutriswaad-r8b",
  fssai: "20426082000023",
  gstin: "10CJTPD2398L1ZV",
  udyam: "UDYAM-BR-38-0065350",
};

export const MARQUEE = ["100% Roasted", "Zero Trans-Fats", "Child-Safe Snacking", "Traditional Purity"];

export const VALUES = [
  { n: "01", title: "Roasted, never fried", text: "100% baked and roasted for a lighter, honest crunch.", points: ["Zero-oil roasting", "Crisp, natural crunch"], testId: "story-card-roasted" },
  { n: "02", title: "No added trans-fats", text: "Better ingredients, without compromising on flavour.", points: ["Naturally gluten-free", "Easily digestible"], testId: "story-card-no-trans-fats" },
  { n: "03", title: "Made for every family", text: "Child-safe snacking with traditional purity at heart.", points: ["Kids to grandparents", "Affordable with health"], testId: "story-card-every-family" },
];

export const PRODUCTS = [
  {
    key: "flavoured-jars",
    name: "Flavoured Makhana Jars",
    label: "Live Range · Available Now",
    text: "100% roasted with advanced zero-oil technology. Naturally gluten-free, easily digestible and guilt-free snacking for all age groups.",
    features: ["Net Wt. 85g PET jar", "Induction foil seal & gold cap", "6-month shelf life"],
    image: "/images/jar-magic-masala.jpg",
    pos: "center 40%",
    span: "lg:col-span-7",
    chips: [
      { name: "9 Regular & Chatpata flavours", cls: "bg-ns-emerald text-ns-ivory border-ns-emerald" },
      { name: "Zero-oil roasted" },
      { name: "Naturally gluten-free" },
      { name: "HSN 20081929" },
    ],
  },
  {
    key: "shuddh-ghee",
    name: "Shuddh Ghee Roasted Makhana",
    label: "Vrat & Upvas Special",
    text: "Roasted in 100% pure deshi ghee, pure and healthy for fasts and festive rituals.",
    features: ["100% pure deshi ghee", "Vrat-friendly", "Net Wt. 85g"],
    image: "/images/ghee-vrat.jpg",
    pos: "center 45%",
    span: "lg:col-span-5",
    chips: [{ name: "Occasional product" }],
  },
  {
    key: "makhana-pops",
    name: "NutriSwaad Makhana Pops",
    label: "Coming Soon · Affordable Range",
    text: "Replacing deep-fried junk chips with an affordable, 100% baked, protein-rich and calcium-dense superfood snack in kid-approved flavours.",
    features: ["High protein", "Roasted", "Zero trans-fat"],
    image: "/images/makhana-pops.jpg",
    pos: "center",
    span: "lg:col-span-5",
    soon: true,
    chips: [
      { name: "Gourmet Cream N' Onion", cls: "bg-[#E6EFD9] text-[#24502F] border-[#BFD3A8]" },
      { name: "Fiery Peri Peri", cls: "bg-[#FBE1D1] text-[#9A3412] border-[#F2B896]" },
      { name: "Affordable with health", cls: "bg-ns-emerald text-ns-ivory border-ns-emerald" },
      { name: "School canteens" },
      { name: "Impulse counters" },
    ],
  },
  {
    key: "upcoming-products",
    name: "Upcoming Products",
    label: "Coming Soon",
    text: "Premium dry fruits, daily staples and wholesome snacks. Every new addition undergoes rigorous quality control to stay 100% pure, safe and nutritious.",
    features: ["Dry fruits", "Daily staples", "Wholesome snacks"],
    image: "/images/upcoming.jpg",
    pos: "center 60%",
    span: "lg:col-span-7",
    soon: true,
    chips: ["Badam", "Kaju", "Pista", "Kismis", "Mungfali", "Roasted Chana", "Pure Chana Sattu", "Multigrain Atta", "Wheat Daliya"].map((name) => ({ name })),
  },
];

export const FLAVOURS = [
  { name: "Tangy Tomato", text: "Zesty aur delicious tomato twist." },
  { name: "Pudina", text: "Fresh mint flavour ke sath cooling taste." },
  { name: "Himalayan Salt & Pepper", text: "Light, healthy aur classic seasoning." },
  { name: "Peri Peri", text: "Bold, spicy aur chatpata international touch." },
  { name: "Magic Masala", text: "Desi spices ka lajawab blend." },
  { name: "Cheese & Chilli", text: "Cheese ki creaminess aur chilli ka kick." },
  { name: "Cream & Onion", text: "Mild creamy aur onion ka standard flavor." },
  { name: "Simply Salt", text: "Pure aur minimalist taste." },
  { name: "Barbeque", text: "Smoky aur rich barbecue flavor." },
];

export const ADVANTAGES = [
  { title: "High margin, rapid turnover", text: "Affordable, healthy packs built for frequent re-orders and fast stock rotation.", icon: "TrendingUp", testId: "b2b-card-high-margin" },
  { title: "Impulse buying pull", text: "Bright, eye-catching packs that earn attention at every counter.", icon: "Zap", testId: "b2b-card-impulse-pull" },
  { title: "Sales support", text: "Promotional collateral and dedicated leadership for your territory.", icon: "Megaphone", testId: "b2b-card-sales-support" },
  { title: "Regional protection", text: "Build with confidence through a focused, partner-first network.", icon: "ShieldCheck", testId: "b2b-card-regional-protection" },
];

export const LEADERS = [
  { name: "Mrs. Chanda Devi", role: "Founder & Owner", initials: "CD", lead: "Foundational Inspiration & Core Values", focus: "Brand Integrity, Strategic Guidance & Rural Empowerment", testId: "leadership-card-chanda-devi" },
  { name: "Mr. Mohit Kumar Gupta", role: "Managing Director (MD)", initials: "MG", lead: "Strategic Vision & Operations", focus: "Product Innovation, Brand Scaling & Tech Integration", testId: "leadership-card-mohit-kumar-gupta" },
  { name: "Mr. Rohit Kumar Gupta", role: "Head of Sales & Marketing", initials: "RG", lead: "Market Expansion & Growth", focus: "B2B Networks, Distributor Relations & Retail Strategy", testId: "leadership-card-rohit-kumar-gupta" },
  { name: "Ms. Khushboo Kumari", role: "Head of Accounts & Finance", initials: "KK", lead: "Financial Governance & Compliance", focus: "Fiscal Discipline, Supply Chain Accounting & Cash Flow", testId: "leadership-card-khushboo-kumari" },
];

export const STATES = ["Bihar", "Uttar Pradesh", "Jharkhand", "West Bengal", "Other"];
export const EXPERIENCE = ["FMCG", "Grocery", "Snacks", "New Business"];
export const INVESTMENT = ["Below ₹1 Lakh", "₹1 Lakh - ₹3 Lakhs", "₹3 Lakhs - ₹5 Lakhs", "Above ₹5 Lakhs"];
